var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.7487V7.01076M10 13.5193V13.5522M14.7249 16.6654H5.27506C3.98425 16.6654 2.89494 15.8123 2.55221 14.6451C2.40591 14.1469 2.58567 13.6279 2.86063 13.1861L7.58557 4.66622C8.69258 2.8873 11.3074 2.8873 12.4144 4.66622L17.1394 13.1861C17.4143 13.6279 17.5941 14.1469 17.4478 14.6451C17.1051 15.8123 16.0157 16.6654 14.7249 16.6654Z",
    stroke: "#4E4E4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.3d4cbbf63b01725877b5bcb5b898e10b.svg";
export { ForwardRef as ReactComponent };